import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-graphite px-3 py-4 sm:px-6" data-id="element-159" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-2xl" data-id="element-160" data-mp="3fz5pc1f45qid">
        <h2 className="text-center font-display text-[1.6rem] font-bold uppercase leading-none text-white sm:text-[2.2rem]" data-id="element-161" data-mp="3fy316196e265">
          WHAT TECHNICIANS <span className="text-volt" data-id="element-162" data-mp="36yzcmhr8ouk9">ARE SAYING</span>
        </h2>
        <div className="mt-2 space-y-2" data-id="element-163" data-mp="370ajwrjw8kg4">
          {testimonials.map(t => <figure key={t.name} className="rounded-md border border-steel/20 border-l-4 border-l-volt bg-carbon px-2.5 py-2" data-id="element-164" data-mp="31z37ugapwz3n">
              <div className="flex gap-0.5 text-volt" role="img" aria-label="5 out of 5 stars" data-id="element-165" data-mp="2x2w4mv9pi1pe">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-166" data-mp="v8dmppcdwidz" data-mpi={i} />)}
              </div>
              <p className="mt-1 text-[0.95rem] font-extrabold leading-tight text-white sm:text-[1.1rem]" data-id="element-167" data-mp="qb54xpv5egd9">
                “{t.headline}”
              </p>
              <blockquote className="mt-0.5 text-[0.78rem] leading-[1.4] text-steel sm:text-[0.9rem]" data-id="element-168" data-mp="m5b43ntn3sht">“{t.quote}”</blockquote>
              <figcaption className="mt-1.5 text-[0.7rem] leading-tight sm:text-[0.8rem]" data-id="element-169" data-mp="79bmnmkn4g00">
                <span className="font-extrabold text-volt" data-id="element-170" data-mp="c7mz852bl4lx">{t.name}</span>
                <span className="text-steel" data-id="element-171" data-mp="zw65kf1t77bd">
                  {' '}
                  — {t.role} · {t.location}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}